import { render, staticRenderFns } from "./like-react-stats.vue?vue&type=template&id=42ce4540&"
import script from "./like-react-stats.vue?vue&type=script&lang=js&"
export * from "./like-react-stats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports